import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../../firebase";
import type { UserUpdateDtoAtAdmin } from "components/userModel";

interface Response {
  success: boolean;
  message: string;
}

interface Props extends UserUpdateDtoAtAdmin {

}

export const updateUserDetail = async (data: Props) => {
  const functions = getFirebaseFunctions();

  const updateUserDetail = httpsCallable<UserUpdateDtoAtAdmin, Response, object>(
    functions,
    "admin_updateUserDetail",
  );

  try {
    const res = await updateUserDetail(data);
    return res.data;
  } catch (error) {
    console.error("Failed to update user detail:", error);
    throw error;
  }
};
